import { Component } from '@angular/core';
import { TABLE_DEFINITION, VaFilteredMatTableService, VaTableSortService } from '@vendasta/va-filter2-table';
import { tableDefinitionFactory } from './user-lists-overview-table-model';
import { UserListsOverviewService } from './user-lists-overview.service';

@Component({
  selector: 'app-user-lists-overview',
  templateUrl: './user-lists-overview.component.html',
  styleUrls: ['./user-lists-overview.component.scss'],
  providers: [
    VaFilteredMatTableService,
    VaTableSortService,
    UserListsOverviewService,
    {
      provide: TABLE_DEFINITION,
      useFactory: tableDefinitionFactory,
    },
  ],
})
export class UserListsOverviewComponent {
  userListImportUrl = '/bc-admin/users/bulk-import';

  constructor(readonly userListsOverviewService: UserListsOverviewService) {}
}
